import axios from 'axios';
import serverMessage from '../server-message';

export default function remove({ id }) {
  return new Promise((resolve, reject) => axios
    .delete(`/account/system-admin/api/v1/bundle/${id}`)
    .then((response) => resolve(response.data))
    .catch((error) => reject(serverMessage(error))));
}
